import types from "../types";

export const fetchnetwork = (network) => ({
  type: types.networkTypes.FETCH_NETWORK_SUCCESS,
  payload: network,
});
